
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiShipBulkcarrier as ObiShipBulkcarrierElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ship-bulkcarrier.js';
 
 
 

 
 export const ObiShipBulkcarrier = createComponent({
   react: React,
   tagName: 'obi-ship-bulkcarrier',
   elementClass: ObiShipBulkcarrierElement,
   events: {
     
   }
  });
 
 